import { formatText } from "util/helper";
import classes from "./SingleNavMenuMobile.module.css";
const { FormattedMessage } = require("react-intl");
const { NavLink } = require("react-router-dom");

const SingleNavMenuMobile = ({ item, setNavOpen }) => {
  return (
    <div className={classes["single-mobile-menu"]}>
      <NavLink
        to={item.url}
        activeClassName={classes.active}
        onClick={() => setNavOpen(false)}
      >
        <FormattedMessage id={formatText(item.title)} />
      </NavLink>
    </div>
  );
};

export default SingleNavMenuMobile;
